<template>
  <div class="">
    <div class="banner">
      <div class="titleSub">lemon product</div>
      <div class="title wow animate__animated durationTime animate__fadeInUp">
        柠檬网联产品
      </div>
      <div class="desc wow animate__animated durationTime animate__fadeInUp">
        科技引领，服务至诚
      </div>
    </div>
    <div class="product">
      <div class="menu">
        <div class="menuCon">
          <div
            class="first-title"
            v-for="(item, index) in productMenus"
            :key="`product-first` + index"
          >
            <div class="label">{{ item.title }}</div>
            <div
              class="second-title cus-pointer"
              v-for="(i, index) in item.children"
              :key="`product-second` + index"
              @click="jump(i.jump)"
            >
              {{ i.title }}
            </div>
          </div>
        </div>
      </div>
      <div class="product-list">
        <div class="box">
          <div class="box-first-title">无线网络产品</div>
          <div class="box-second-title anchorDiv" id="znlj">
            <div class="desc">智能联接</div>
            <div class="icon">
              <img
                style="width: 0.1151rem;height:0.2016rem;margin-top: 0.05rem"
                src="../../assets/image/product/icon-left.png"
              />
            </div>
          </div>
          <div class="product-item item-le-product">
            <div
              :class="['item','wow' ,'animate__animated ','durationTime', 'animate__fadeInUp',item.detail!=undefined?'cus-pointer':'disabled-cursor']"
              v-for="(item, index) in intelligentConnection"
              :key="`product-item` + index"
              @click="handleDetail(item.id)"
            >
              <img
                style="width: 1.67rem"
                :src="require(`@/assets/${item.imageSrc}`)"
              />
              <div class="introduce">
                <div class="title">{{ item.name }}</div>
                <div class="desc">{{ item.desc }}</div>
                <div class="more">
                  <div>探索更多</div>
                  <img
                    style="width: 0.2rem;height: 0.2rem;"
                    src="@/assets/image/index/index-product-detail.png"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="box-second-title anchorDiv" id="ywgl">
            <div class="desc">运营管理</div>
            <div class="icon">
              <img
                style="width: 0.1151rem;height:0.2016rem;margin-top: 0.05rem"
                src="../../assets/image/product/icon-left.png"
              />
            </div>
          </div>
          <div class="product-item item-le-product">
            <div
              :class="['item','wow' ,'animate__animated ','durationTime', 'animate__fadeInUp',item.detail!=undefined?'cus-pointer':'disabled-cursor']"
              @click="handleDetail(item.id)"
              v-for="(item, index) in operationManagement"
              :key="`product-item-operationManagement` + index"
            >
              <img style="width: 1.67rem" :src="require(`@/assets/${item.imageSrc}`)" />
              <div class="introduce">
                <div class="title">{{ item.name }}</div>
                <div class="desc">{{ item.desc }}</div>
                <div class="more">
                  <div>探索更多</div>
                  <img
                    style="width: 0.2rem;height: 0.2rem;"
                    src="@/assets/image/index/index-product-detail.png"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="box-second-title anchorDiv" id="gjfz">
            <div class="desc">高阶辅助</div>
            <div class="icon">
              <img
                style="width: 0.1151rem;height:0.2016rem;margin-top: 0.05rem"
                src="../../assets/image/product/icon-left.png"
              />
            </div>
          </div>
          <div class="product-item item-le-product">
            <div
              :class="['item','wow' ,'animate__animated ','durationTime', 'animate__fadeInUp',item.detail!=undefined?'cus-pointer':'disabled-cursor']"
              v-for="(item, index) in assistance"
              :key="`product-item-assistance` + index"
              @click="handleDetail(item.id)"
            >
              <img style="width: 1.67rem" :src="require(`@/assets/${item.imageSrc}`)" />
              <div class="introduce">
                <div class="title">{{ item.name }}</div>
                <div class="desc">{{ item.desc }}</div>
                <div class="more">
                  <div>探索更多</div>
                  <img
                    style="width: 0.2rem;height: 0.2rem;"
                    src="@/assets/image/index/index-product-detail.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box">
          <div class="box-first-title">智慧校园产品</div>
<!--          <div class="box-second-title">-->
<!--            <div class="desc">智能联接</div>-->
<!--            <div class="icon">-->
<!--              <img-->
<!--                style="width: 0.1151rem;height:0.2016rem;margin-top: 0.05rem"-->
<!--                src="../../assets/image/product/icon-left.png"-->
<!--              />-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="product-item item-le-product">-->
<!--            <div-->
<!--              class="item wow animate__animated durationTime animate__fadeInUp"-->
<!--              v-for="(item, index) in intelligentConnection"-->
<!--              :key="`product-item` + index"-->
<!--            >-->
<!--              <img style="width: 1.67rem" :src="require(`@/assets/${item.imageSrc}`)" />-->
<!--              <div class="introduce">-->
<!--                <div class="title">{{ item.name }}</div>-->
<!--                <div class="desc">{{ item.desc }}</div>-->
<!--                <div class="more">-->
<!--                  <div>探索更多</div>-->
<!--                  <img-->
<!--                    style="width: 0.2rem;height: 0.2rem;"-->
<!--                    src="@/assets/image/index/index-product-detail.png"-->
<!--                  />-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
          <div class="box-second-title anchorDiv" id="zhwl">
            <div class="desc">智能终端</div>
            <div class="icon">
              <img
                style="width: 0.1151rem;height:0.2016rem;margin-top: 0.05rem"
                src="../../assets/image/product/icon-left.png"
              />
            </div>
          </div>
          <div class="product-item item-le-product">
            <div
              :class="['item','wow' ,'animate__animated ','durationTime', 'animate__fadeInUp',item.detail!=undefined?'cus-pointer':'disabled-cursor']"
              v-for="(item, index) in smartIoT"
              :key="`product-item-smartIoT` + index"
              @click="handleDetail(item.id)"
            >
              <img style="width: 1.67rem" :src="require(`@/assets/${item.imageSrc}`)" />
              <div class="introduce">
                <div class="title">{{ item.name }}</div>
                <div class="desc">{{ item.desc }}</div>
                <div class="more">
                  <div>探索更多</div>
                  <img
                    style="width: 0.2rem;height: 0.2rem;"
                    src="@/assets/image/index/index-product-detail.png"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="box-second-title anchorDiv" id="zhyy">
            <div class="desc">智慧应用</div>
            <div class="icon">
              <img
                style="width: 0.1151rem;height:0.2016rem;margin-top: 0.05rem"
                src="../../assets/image/product/icon-left.png"
              />
            </div>
          </div>
          <div class="product-item item-le-product">
            <div
              :class="['item','wow' ,'animate__animated ','durationTime', 'animate__fadeInUp',item.detail!=undefined?'cus-pointer':'disabled-cursor']"
              v-for="(item, index) in smartApplications"
              :key="`product-item-smartIoT` + index"
              @click="handleDetail(item.id)"
            >
              <img style="width: 1.67rem" :src="require(`@/assets/${item.imageSrc}`)" />
              <div class="introduce">
                <div class="title">{{ item.name }}</div>
                <div class="desc">{{ item.desc }}</div>
                <div class="more">
                  <div>探索更多</div>
                  <img
                    style="width: 0.2rem;height: 0.2rem;"
                    src="@/assets/image/index/index-product-detail.png"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import { backItem } from "../../util/util";
import productData from "./productsData";

export default {
  metaInfo() {
    return {
      title: '学校智慧校园_智慧校园服务方案_智慧校园软件系统_柠檬网联', // 动态标题
      meta: [
        { name: 'description', content: '柠檬网联是中国数智园区、无线网络解决方案提供商及运营服务商。历经10年发展，已经设计研发了学校智慧校园、智慧校园服务方案、智慧校园软件系统、无线网络相关一系列的软件、硬件和平台，融合物联网、大数据、云计算、人工智能等新一代信息技术，形成了以网络为基础，以数智校园、数智厂园为应用的“一体两翼”的发展格局，以网络化、数字化、智能化持续助力学校和企业园区的数字化转型升级。'}, // 动态描述
        { name: 'keywords', content: '学校智慧校园,智慧校园服务方案,智慧校园软件系统' } // 动态关键词
      ]
    };
  },
  name: "index",
  data() {
    return {
      productMenus: [
        {
          title: "无线网络产品",
          children: [
            { title: "智能联接", jump: "znlj" },
            { title: "运维管理", jump: "ywgl" },
            { title: "高阶辅助", jump: "gjfz" }
          ]
        },
        {
          title: "智慧校园产品",
          children: [
            { title: "智能终端", jump: "zhwl" },
            { title: "智慧应用", jump: "zhyy" }
          ]
        }
      ],
      intelligentConnection: [],
      operationManagement: [],
      assistance: [],
      smartIoT: [],
      smartApplications: []
    };
  },
  mounted() {
    // init wow
    const wow = new WOW({
      boxClass: "wow", //需要执行动画元素的Class
      animateClass: "animated_lightSpeedIn", //animation.css动画的Class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备执行动画
      live: true //异步加载的内容是否有效
    });
    wow.init();
  },
  created() {
    this.initProductList();
  },
  methods: {
    handleDetail(id) {
      let productsDetail = productData.filter(v => id == v.id)[0];
      if(productsDetail.detail===undefined || productsDetail.jump===undefined){
        return;
      }
      let routeName=productsDetail.jump==='hardware'?'productDetail':'productDetailSoft'
      this.$router.push({
        name: routeName,
        query: {
          id: id
        }
      });
    },
    jump(id) {
      backItem(id);
    },
    initProductList() {
      this.intelligentConnection = productData.filter(
        v => v.type === "智能联接"
      );
      this.operationManagement = productData.filter(v => v.type === "运维管理");
      this.assistance = productData.filter(v => v.type === "高阶辅助");
      this.smartIoT = productData.filter(v => v.type === "智能终端");
      this.smartApplications = productData.filter(v => v.type === "智慧应用");
    }
  }
};
</script>

<style scoped lang="scss">
.banner {
  width: 100%;
  height: 5.8rem;
  background: url("../../assets/image/product/product-bg.png") center no-repeat;
  background-size: cover;

  .title {
    font-size: 0.44rem;
    font-weight: 500;
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    margin-top: 2.35rem;
    margin-left: 2.18rem;
    position: relative;
    color: #fff;
    display: inline-block;
  }

  .titleSub {
    content: "Collaboration Cases";
    position: absolute;
    margin-top: 2.04rem;
    margin-left: 2.18rem;
    font-size: 0.44rem;
    font-weight: 500;
    color: rgb(169 160 160 / 51%);
    text-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    letter-spacing: 0.02rem;
  }

  .desc {
    font-weight: 400;
    font-size: 0.24rem;
    color: #ffffff;
    margin-top: 0.2rem;
    margin-left: 2.18rem;
  }
}

.product {
  display: flex;
  padding: 1rem 2.18rem;

  .menu {
    width: 2.45rem;
    position: relative;
    .menuCon {
      position: sticky;
      top: 1rem;
    }
    .first-title {
      font-weight: 500;
      font-size: 0.22rem;
      color: #333333;
      // border-bottom: 0.02rem solid #E6E6E6;
      margin-top: 0.4rem;
      padding-bottom: 0.2rem;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 1.45rem;
        height: 0.02rem;
        background: #e6e6e6;
      }
    }
    .first-title:last-child::after {
      opacity: 0;
    }
    .first-title:first-child {
      margin-top: 0;
    }
    .label {
      margin-bottom: 0.4rem;
    }
    .second-title {
      font-weight: 400;
      font-size: 0.16rem;
      color: #333333;
      margin-bottom: 0.2rem;
    }
  }
  .product-list {
    flex: 1;
    &::-webkit-scrollbar {
      display: none;
    }

    .box:first-child {
      padding-top: 0;
    }
    .box {
      padding-top: 0.4rem;
      .box-first-title {
        font-weight: 500;
        font-size: 0.26rem;
        color: #333333;
        margin-bottom: 0.4rem;
      }
      .box-second-title {
        margin-top: 0.4rem;
        display: flex;
        align-items: center;
        .desc {
          font-weight: 500;
          font-size: 0.22rem;
          color: #333333;
          margin-right: 0.2rem;
        }
      }
      .box-second-title:first-child {
        margin-top: 0;
      }
      .product-item {
        padding: 0.2rem 0 0.2rem 0;
        align-items: center;
        flex-wrap: wrap;
        display: flex;
        justify-content: space-between;
        border-bottom: 0.02rem solid #e6e6e6;
        .item {
          &:hover {
            background: url("../../assets/image/product/product-item-bg.png")
              center no-repeat;
            background-size: cover;
            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
            .introduce {
              .desc {
                color: #333333;
              }
            }
            background-color: #f6f6f6;
          }
          //cursor: pointer;
          display: flex;
          width: calc((100% - 0.2rem) / 2);
          align-items: center;
          background: #f6f6f6;
          padding: 0.2rem;
          margin-bottom: 0.2rem;
          transition: all 0.3s ease-in-out;
          .introduce {
            //width: 3.5rem;
            margin-left: 0.44rem;
            .title {
              font-weight: 500;
              font-size: 0.2rem;
              color: #333333;
              margin-bottom: 0.2rem;
            }
            .desc {
              font-weight: 400;
              font-size: 0.16rem;
              color: #666666;
              margin-bottom: 0.2rem;
              text-indent: 2em;
            }
            .more {
              display: flex;
              align-items: center;
              div {
                font-weight: 400;
                font-size: 0.16rem;
                color: #333333;
                margin-right: 0.1rem;
              }
            }
          }
        }
      }
    }
  }
}
.item-le-product:last-child {
  border: 0 !important;
}

.anchorDiv {
  scroll-margin-top: 1.3rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/product/index.vue